import { Dialog, DialogContent, Typography, DialogActions, Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';

type VisitDetailPhotoDeleteDialogProps = {
  open: boolean;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const VisitDetailPhotoDeleteDialog = ({
  open,
  isDeleting,
  onConfirm,
  onCancel,
}: VisitDetailPhotoDeleteDialogProps) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogContent>
        <Typography>
          <FormattedMessage
            id="hairstyle.photo.delete.confirm"
            defaultMessage="Opravdu chcete smazat tuto fotografii?"
          />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isDeleting}>
          <FormattedMessage id="common.cancel" defaultMessage="Zrušit" />
        </Button>
        <Button onClick={onConfirm} color="error" disabled={isDeleting}>
          <FormattedMessage id="common.delete" defaultMessage="Smazat" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VisitDetailPhotoDeleteDialog;
